import styled from "styled-components";

export const Wrapper = styled.div``;

export const Fieldset = styled.fieldset`
  position: relative;
  height: ${(p) => p.height}px;
  border: ${(p) =>
    p.error
      ? `1px solid ${p.theme.color[p.error]}`
      : p.focused
      ? `1px solid ${p.theme.color.primary}`
      : "1px solid #ccc"};
  border-radius: 4px;
  background-color: ${(p) => (p.disabled ? "#eee" : "white")};
  transition: all 150ms ease;
  z-index: 1;

  &:hover {
    border-color: ${(p) => !p.disabled && !p.error && p.theme.color.primary};
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Legend = styled.legend`
  height: 0;
  width: auto;
  padding: 0 4px;
  margin-top: 12px;
  margin-bottom: 0;
  margin-left: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  // transform: scale(0.75);
  color: transparent;
`;

export const InputField = styled.input`
  width: 100%;
  height: ${(p) => p.height}px;
  padding: 0 15px;
  border: none;
  font-size: 16px;
  color: #444;
  border: ${(p) =>
    p.error
      ? `1px solid ${p.theme.border[p.error]}`
      : p.focused
      ? `1px solid ${p.theme.border.primary}`
      : "1px solid #ccc"};
  border-radius: 4px;
  background-color: ${(p) => (p.disabled ? "#eee" : "white")};

  &:focus {
    outline: none;
  }

  &:hover {
    border-color: ${(p) => !p.disabled && !p.error && p.theme.color.primary};
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  height: ${(p) => p.height}px;
  padding: 18px 15px;
  border: none;
  font-size: 16px;
  color: #444;
  resize: none;
  border: ${(p) =>
    p.error
      ? `1px solid ${p.theme.color[p.error]}`
      : p.focused
      ? `1px solid ${p.theme.color.primary}`
      : "1px solid #ccc"};
  border-radius: 4px;
  background-color: ${(p) => (p.disabled ? "#eee" : "white")};

  &:focus {
    outline: none;
  }

  &:hover {
    border-color: ${(p) => !p.disabled && !p.error && p.theme.color.primary};
  }
`;

export const Label = styled.label`
  font-weight: bold;
  font-size: 1rem;
  color: ${(p) => (p.error ? p.theme.colors[p.error] : p.theme.colors.primary)};
`;

export const ConfirmationValueInputWrapper = styled.div`
  margin-top: 12px;
`;
